const CASINO_AUTHENTICATE_PATH = 'auth/authenticate';

type CreateCasinoSessionToken = (boToken: string) => Promise<string | undefined>;

type ResolveRequestAuthorizationParams = {
  apiService?: string;
  path?: string;
  boToken?: string;
  createCasinoSessionToken: CreateCasinoSessionToken;
};

let cachedCasinoAuthToken: { baseToken: string; casinoToken: string } | null = null;

export const clearCasinoAuthTokenCache = () => {
  cachedCasinoAuthToken = null;
};

export const isCasinoAuthenticatePath = (path?: string) => {
  return path?.replace(/^\/+/, '') === CASINO_AUTHENTICATE_PATH;
};

export const resolveRequestAuthorizationToken = async ({
  apiService,
  path,
  boToken,
  createCasinoSessionToken,
}: ResolveRequestAuthorizationParams) => {
  if (!boToken) return undefined;

  if (apiService !== 'casino') return boToken;

  if (isCasinoAuthenticatePath(path)) return undefined;

  if (cachedCasinoAuthToken?.baseToken === boToken) {
    return cachedCasinoAuthToken.casinoToken;
  }

  const casinoToken = await createCasinoSessionToken(boToken);

  if (!casinoToken) {
    throw new Error('Casino authentication did not return an access token.');
  }

  cachedCasinoAuthToken = { baseToken: boToken, casinoToken };

  return casinoToken;
};
